import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Callout, ColorPicker, FontWeights, getTheme, mergeStyleSets, Modal, } from "@fluentui/react";
import { Box, CircularProgress } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import "./style.css";

import { SeasonSettings } from "../SeasonSettings";
import Tabs from '../Tabs';

import DropDownSeasonSettings from "../../../components/DropDownSeasonSettings/DropDownSeasonSettings";
import { FiRrCommentInfo } from "../../../icons/FiRrCommentInfo/FiRrCommentInfo";
import { TemplateEmptyVuesaxLinearProperty332 } from "../../../icons/TemplateEmptyVuesaxLinearProperty332/TemplateEmptyVuesaxLinearProperty332";

import rightarrow from '../../../icons/ImageIcons/keyboard-arrow-right.svg';
import homeImage from '../../../icons/ImageIcons/material-symbols_home-rounded.svg';
import uploadIcon from '../../../icons/ImageIcons/upload-icon.png';

import { useBoolean } from "@fluentui/react-hooks";

import { Checkbox } from "../../../components/Checkbox";


import 'react-toastify/dist/ReactToastify.css';
import ImageModal from "../../../components/ImageCropper/ImageModal";
import { getClientData, toastError } from "../../../constants/Constants";
import { createSeasonSettingsClientMaster, fetchClientMaster, getExitVideoForSettings, getSelectedSeason, postExitVideoForSettings, setEventSuccess } from "../../../store/Actions/SeasonSettingsAction";
import { getSafeFileNameError } from "../../../utils/fileNameValidation";

const CreateExitClipFrameSeasonSettings = ({ loading, clientMasterData, exitVideoDataForSettings, getExitVideoData, postExitVideo, selectedSeason, getSelectedSeason, setEventSuccess, eventSuccess, createSeasonSettingsClientMaster, fetchClientMaster }) => {
  const [
    isModalOpen_Images_logo,
    { setTrue: showModal_Images_logo, setFalse: hideModal_Images_logo },
  ] = useBoolean(false);
  const [preview_Images_logo, setPreview_Images_logo] = useState("");
  const [isCalloutVisible_Images, { toggle: toggleIsCalloutVisible_Images }] =
    useBoolean(false);
  const [isCalloutVisible_Url, { toggle: toggleIsCalloutVisible_Url }] = useBoolean(false);
  const [imageBordercolor, setimageBordercolor] = React.useState("#d9d9d9");
  const [isCalloutVisible_Heading, { toggle: toggleIsCalloutVisible_Heading }] =
    useBoolean(false);
  const [headingColor, setheadingColor] = React.useState("#000000");
  const [urlColor, setUrlColor] = React.useState("#d9d9d9");
  // State variables to track logo upload, text entered, and background color
  const [isLogoUploaded, setIsLogoUploaded] = useState(false);
  const [textchangeHeading, setTextChangeHeading] = useState('CONGRATULATIONS');
  const [textchangeUrl, setTextChangeUrl] = React.useState('');
  const [isBackgroundColorSet, setIsBackgroundColorSet] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [seasonId, setSeasonId] = useState(0);
  const [seasonName, setSeasonName] = useState('');
  const [seasonStartPeriod, setSeasonStartPeriod] = useState('');
  const [seasonEndPeriod, setSeasonEndPeriod] = useState('');

  const [selectedImageForCropping, setSelectedImageForCropping] = useState(null);
  const [isCroppingForLogo, setIsCroppingForLogo] = useState(false);
  const [completedCrop, setCompletedCrop] = useState(null);

  const navigate = useNavigate();
  const clientData = getClientData();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const createVideo = searchParams.get('createVideo');

  useEffect(() => {
    const fetchData = async () => {
      if (seasonName) {
        await fetchClientMaster({ clientId: clientData.clientID, seasonName: seasonName});
        await getExitVideoData({ ClientId: clientData.clientID, seasonName: seasonName})
      }
    };
  
    fetchData();
  }, [seasonName, selectedSeason]);

  useEffect(() => {
    if (!createVideo) {
      if (exitVideoDataForSettings?.result?.data?.createVideo === false || exitVideoDataForSettings?.result?.isDataAvailable === false) {
        navigate('/CreateExitClipSettings');
      }
    }
      setheadingColor(exitVideoDataForSettings?.result?.data?.exitVideo?.frameBGColor || "#000000");
      setTextChangeHeading(exitVideoDataForSettings?.result?.data?.exitVideo?.textAsset?.[0]?.textData || 'CONGRATULATIONS');
      setTextChangeUrl(exitVideoDataForSettings?.result?.data?.exitVideo?.textAsset?.[1]?.textData || '');
      setimageBordercolor(exitVideoDataForSettings?.result?.data?.exitVideo?.textAsset?.[0]?.textColor || "#d9d9d9");
      setUrlColor(exitVideoDataForSettings?.result?.data?.exitVideo?.textAsset?.[1]?.textColor || "#d9d9d9");
      setPreview_Images_logo({ url: exitVideoDataForSettings?.result?.data?.exitVideo?.logoPathSasUri, uploadedData: true }, {});
      
  }, [exitVideoDataForSettings])

  useEffect(() => {
    if (eventSuccess && !loading) {
      console.log("Event created successfully!");
      setEventSuccess(false);
      navigate("/");
    }
  }, [eventSuccess, loading]);

  // Function to handle text input
  const handleTextChange = (inputValue, text) => {
    if (text === "Heading") {
      if (inputValue.target.value.length <= 50) {
        setTextChangeHeading(inputValue.target.value);
      }
    }
    if (text === "Url") {
      if (inputValue.target.value.length <= 160) {
        // Limiting to 2 lines
        if (inputValue.target.value.split("\n").length <= 2) {
          setTextChangeUrl(inputValue.target.value);
        }
      }
    }
  };

  // Function to handle background color change
  const handleBackgroundColorChange = () => {

    setIsBackgroundColorSet(true);
    toggleIsCalloutVisible_Heading(); // Close the color picker callout
  };


  // Function to handle background color change
  const onChangeBackgroundColor_Images = React.useCallback((ev, colorObj) => {
    setimageBordercolor(colorObj.str);
    setIsBackgroundColorSet(true); // Set isBackgroundColorSet to true
  }, []);

  // Function to handle background color change
  const onChangeBackgroundColor_Heading = React.useCallback((ev, colorObj) => {
    setheadingColor(colorObj.str);
    setIsBackgroundColorSet(true); // Set isBackgroundColorSet to true
  }, []);

  // Function to handle background color change
  const onChangeBackgroundColor_Url = React.useCallback((ev, colorObj) =>
  setUrlColor(colorObj.str), []);

  // Adds the user selected logo/image file to the UI
  const handleOnChange_logo = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      const fileNameError = getSafeFileNameError(file);
      if (fileNameError) {
        toastError(fileNameError);
        e.target.value = null;
        return;
      }
      const reader = new FileReader();

      const allowedTypes = ['image/png'];
      if (!allowedTypes.includes(file.type)) {
        toastError('Invalid file type. Please select a .png file.');
      } else {
        reader.onload = function () {
          const image = new Image();
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            if (width >= 500 && height >= 500) {
              setSelectedImageForCropping({name: file.name, url: reader.result});
              setIsLogoUploaded(true);
              showModal_Images_logo();
            } else {
              toastError('File is not in given dimensions');
            }
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    }
  };
  
  // Opens modal to upload logo
  const render_preview_logo=()=>{
    setIsCroppingForLogo(true);
    // setIsLogoUploaded(false);
    hideModal_Images_logo();
  }

  // Closes the upload logo modal
  const handleCloseModal = () => {
    hideModal_Images_logo();
    setIsLogoUploaded(false); // Reset logoUploaded state when modal is closed
  };

  // Opens file explorer to select the desired file
  const openUpload_logo = () => {
    if (document.getElementById("image_upload_logo") != undefined) {
      document.getElementById("image_upload_logo").click();
    }
  };

  // Handles redirection between upload and create video
  const handleSeasonChange = () => {
    searchParams.forEach((value, key) => {
      searchParams.delete(key);
    });

    // Reassign the modified searchParams object to location.search
    location.search = searchParams.toString();
  };

  // Set the selected season name
  const handleSeasonName = (seasonName, seasonId) => {
    setSeasonName(seasonName);
    getSelectedSeason(seasonId);
    setSeasonId(seasonId);
  };

  // Set the selected season dates
  const handleSeasonDates = (startDate, endDate) => {
    setSeasonStartPeriod(startDate);
    setSeasonEndPeriod(endDate);
  }

  // Determine the button text based on completion of actions
  const buttonText = () => {
    if (isLogoUploaded || exitVideoDataForSettings?.result?.data?.exitVideo?.logoPathSasUri) {
      return "Save and Continue";
    } else {
      return "Continue";
    }
  };

  // Uploads the data for the creation of exit video
  const handleSaveContinueClick = async () => {

    if (!seasonName) {
      toastError('Please select Season from dropdown.');
      return;
    }

    if(textchangeHeading === ''){
      toastError('Please add some text.');
      return;
    }

    if ((!preview_Images_logo?.url && !selectedImageForCropping)) {
      toastError('Please select file for logo');
      return;
    }

    // Prepare the text assets array
    const textAssets = [
      { textId: "1", textData: textchangeHeading, textFontStyle: "BOLD", textColor: imageBordercolor },
    ];
    // Include URL text if it's not empty
    if (textchangeUrl !== '') {
      textAssets.push({ textId: "2", textData: textchangeUrl, textFontStyle: "BoldItalic", textColor: urlColor });
    }

    if (buttonText() == "Save and Continue") {
      let logoDetails;
      // setLoading(true)

      if (preview_Images_logo?.uploadedData) {
        logoDetails = {
          logoName: exitVideoDataForSettings?.result?.data?.exitVideo?.logoName,
          logoPath: exitVideoDataForSettings?.result?.data?.exitVideo?.logoPath,
        };
      } else {
        logoDetails = {
          logoName: preview_Images_logo.name,
        };
      }

      const clientData = getClientData();
      if(clientData){

        if(!clientMasterData?.result?.data?.template){
          await createSeasonSettingsClientMaster({
            itemType: "SeasonSettingsMaster",
            itemTypeDesc: "SeasonSettingsMaster",
            clientId: clientData.clientID,
            clientName: clientData.clientName,
            seasonId: seasonId,
            seasonName: seasonName,
            seasonStartDate: seasonStartPeriod,
            seasonEndDate: seasonEndPeriod,
            template: 'Standard',
            templateDesc: 'Standard',
          });
        }

      await postExitVideo(selectedFiles, {
        clientId: clientData.clientID,
        clientName: clientData.clientName,
        seasonName: seasonName,
        seasonStartPeriod: seasonStartPeriod,
        seasonEndPeriod: seasonEndPeriod,
        createVideo: true,
        exitVideo: {
          frameBGColor: headingColor,
          textAsset: textAssets,
          ...logoDetails,
        },
        updatedOn: new Date(),
        updatedBy: clientData.userEmail
      });
      // setLoading(false)
    }
  }

  };


  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  // Closes the cropper modal
  const onCloseCropper = () => {
    setIsCroppingForLogo(false);
  }

  return (
    <div className="create-exit-frame-settings">
      <div className="div-3">
        <SeasonSettings />
        <div className="frame-12">
          <div className="frame-13">
            <div className="section-title">
              <div className="frame-14">
                <div className="page-title">
                  <div className="text-wrapper-4">Season Settings</div>
                </div>
                <div className="breadcrum">
                  <img
                    className="material-symbols"
                    alt="Material symbols"
                    src={homeImage}/>
                  <img
                    className="keyboard-arrow-right"
                    alt="Keyboard arrow right"
                    src={rightarrow} />
                  <div className="text-wrapper-5">Settings</div>
                  <img
                    className="keyboard-arrow-right"
                    alt="Keyboard arrow right"
                    src={rightarrow}/>
                  <div className="text-wrapper-6">Create Exit Clip Frame Settings</div>
                </div>
              </div>
            </div>
            <div className="label">
              <div className="event-ID">Select Season Name</div>
            </div>

            <StyledEngineProvider injectFirst>
              <DropDownSeasonSettings handleSeasonChange={handleSeasonChange} onSeasonsName={handleSeasonName} selectedSeason={selectedSeason} onSeasonDates={handleSeasonDates}/>
            </StyledEngineProvider>
            <StyledEngineProvider injectFirst>
              <Tabs />
            </StyledEngineProvider>
            <div className="frame-15">
              <div className="frame-16">
                    <div className="frame-18">
                      <div className="frame-19">
                        <div className="frame-20">
                          <div className="frame-21">
                            <div className="text-wrapper-7">
                              Create Exit Clip
                            </div>
                          </div>
                          <div className="frame-22">
                            <div className="frame-23">
                              <div className="component-wrapper">
                                <TemplateEmptyVuesaxLinearProperty332 className="template-empty" />
                              </div>
                              <p className="video-tutorial-how">
                                <span className="span">Video Tutorial: </span>
                                <span className="text-wrapper-8">
                                  How to Generate an Exit Clip?
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <FiRrCommentInfo
                          className="icon-instance-node"
                          color="#7E7E7E"
                        />
                      </div>
                  </div>
                  
                  <div
                    className="exit-clip-root"
                    style={{
                      backgroundColor:
                        headingColor != "" ? headingColor : "#000000",
                    }}
                    >
                    <div
                      className="edit-icon-backgroundcolor"
                      id="callout-button-2"
                      onClick={toggleIsCalloutVisible_Heading}
                    >
                      <div>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_117_4650)">
                        <path d="M12.4375 0.620374L4.30951 8.74837C3.99907 9.05714 3.75296 9.42441 3.58543 9.82894C3.4179 10.2335 3.33227 10.6672 3.33351 11.105V12.0004C3.33351 12.1772 3.40375 12.3468 3.52877 12.4718C3.6538 12.5968 3.82336 12.667 4.00018 12.667H4.89551C5.33335 12.6683 5.76709 12.5827 6.17161 12.4151C6.57614 12.2476 6.94341 12.0015 7.25218 11.691L15.3802 3.56304C15.7698 3.17249 15.9886 2.64336 15.9886 2.09171C15.9886 1.54006 15.7698 1.01093 15.3802 0.620374C14.984 0.241636 14.457 0.0302734 13.9088 0.0302734C13.3607 0.0302734 12.8337 0.241636 12.4375 0.620374ZM14.4375 2.62037L6.30951 10.7484C5.93359 11.122 5.42551 11.3323 4.89551 11.3337H4.66684V11.105C4.66823 10.575 4.87855 10.067 5.25218 9.69104L13.3802 1.56304C13.5226 1.42701 13.7119 1.3511 13.9088 1.3511C14.1058 1.3511 14.2951 1.42701 14.4375 1.56304C14.5775 1.70338 14.6561 1.8935 14.6561 2.09171C14.6561 2.28991 14.5775 2.48003 14.4375 2.62037Z" fill="#D9D9D9"/>
                        <path d="M15.3333 5.986C15.1565 5.986 14.987 6.05624 14.8619 6.18126C14.7369 6.30629 14.6667 6.47586 14.6667 6.65267V10H12C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12V14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V3.33333C1.33333 2.8029 1.54405 2.29419 1.91912 1.91912C2.29419 1.54405 2.8029 1.33333 3.33333 1.33333H9.36133C9.53815 1.33333 9.70771 1.2631 9.83274 1.13807C9.95776 1.01305 10.028 0.843478 10.028 0.666667C10.028 0.489856 9.95776 0.320286 9.83274 0.195262C9.70771 0.0702379 9.53815 0 9.36133 0L3.33333 0C2.4496 0.00105857 1.60237 0.352588 0.97748 0.97748C0.352588 1.60237 0.00105857 2.4496 0 3.33333L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H10.8953C11.3333 16.0013 11.7671 15.9156 12.1718 15.7481C12.5764 15.5806 12.9438 15.3345 13.2527 15.024L15.0233 13.252C15.3338 12.9432 15.58 12.576 15.7477 12.1715C15.9153 11.767 16.0011 11.3332 16 10.8953V6.65267C16 6.47586 15.9298 6.30629 15.8047 6.18126C15.6797 6.05624 15.5101 5.986 15.3333 5.986ZM12.31 14.0813C12.042 14.3487 11.7031 14.5337 11.3333 14.6147V12C11.3333 11.8232 11.4036 11.6536 11.5286 11.5286C11.6536 11.4036 11.8232 11.3333 12 11.3333H14.6167C14.5342 11.7023 14.3493 12.0406 14.0833 12.3093L12.31 14.0813Z" fill="#D9D9D9"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_117_4650">
                        <rect width="16" height="16" fill="#D9D9D9"/>
                        </clipPath>
                        </defs>
                        </svg>
                      </div>
                    </div>

                    <div className="parent">
                      <div className="child">
                        <div className="exit-clip-upload-logo" onClick={showModal_Images_logo}>
                          <div
                            className="upload-icon"
                            onClick={showModal_Images_logo}
                          >
                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_212_9007)">
                              <path d="M12.7661 4.92056C12.6455 4.88616 12.5354 4.82215 12.4459 4.73436C12.3563 4.64657 12.2902 4.53778 12.2534 4.41789C12.0492 3.72592 11.7068 3.08257 11.2468 2.52676C10.7869 1.97095 10.2189 1.51424 9.57734 1.18427C8.93576 0.854296 8.23391 0.657925 7.51425 0.607035C6.79459 0.556145 6.07208 0.651796 5.39046 0.888198C4.70883 1.1246 4.08225 1.49684 3.54864 1.98239C3.01503 2.46794 2.58548 3.05671 2.28598 3.71306C1.98648 4.36942 1.82327 5.07972 1.80621 5.80097C1.78915 6.52223 1.9186 7.23945 2.18673 7.90923C2.24833 8.05018 2.26159 8.20755 2.22445 8.35682C2.18731 8.5061 2.10186 8.6389 1.9814 8.73456C1.45055 9.12856 1.03609 9.65874 0.781899 10.269C0.527702 10.8793 0.443222 11.5469 0.537398 12.2012C0.684367 13.0858 1.14361 13.8884 1.83179 14.4633C2.51996 15.0382 3.39144 15.3473 4.28806 15.3346H7.83273C8.00954 15.3346 8.17911 15.2643 8.30414 15.1393C8.42916 15.0143 8.4994 14.8447 8.4994 14.6679C8.4994 14.4911 8.42916 14.3215 8.30414 14.1965C8.17911 14.0715 8.00954 14.0012 7.83273 14.0012H4.28806C3.71225 14.0152 3.15048 13.8224 2.70457 13.4578C2.25866 13.0933 1.95811 12.581 1.8574 12.0139C1.79353 11.597 1.84529 11.1707 2.00705 10.7812C2.1688 10.3918 2.43434 10.0542 2.77473 9.80523C3.13228 9.538 3.39092 9.15957 3.51002 8.72938C3.62912 8.29919 3.60194 7.84162 3.43273 7.42856C3.09817 6.54503 3.08096 5.57271 3.38406 4.67789C3.6262 3.97695 4.05979 3.35781 4.63572 2.89063C5.21165 2.42345 5.90691 2.1269 6.64273 2.03456C6.81341 2.01259 6.98531 2.00145 7.1574 2.00123C8.01943 1.99838 8.8592 2.27485 9.55096 2.78922C10.2427 3.3036 10.7493 4.02821 10.9947 4.85456C11.0906 5.16947 11.2632 5.45561 11.4971 5.6872C11.731 5.91879 12.0189 6.08856 12.3347 6.18123C13.1077 6.40984 13.7924 6.86914 14.2972 7.49764C14.802 8.12614 15.1027 8.89383 15.1591 9.69795C15.2155 10.5021 15.0249 11.3042 14.6128 11.997C14.2008 12.6899 13.5869 13.2403 12.8534 13.5746C12.7448 13.6301 12.6541 13.7151 12.5915 13.8198C12.5289 13.9245 12.497 14.0446 12.4994 14.1666C12.4981 14.2769 12.5245 14.3857 12.5763 14.4832C12.628 14.5806 12.7034 14.6635 12.7955 14.7242C12.8876 14.785 12.9935 14.8216 13.1034 14.8307C13.2134 14.8399 13.3239 14.8212 13.4247 14.7766C16.1807 13.4519 17.6781 9.96723 15.3447 6.60056C14.7023 5.76251 13.7923 5.16964 12.7661 4.92056Z" fill="white"/>
                              <path d="M12.9716 11.1364C13.0966 11.0113 13.1668 10.8418 13.1668 10.665C13.1668 10.4882 13.0966 10.3187 12.9716 10.1937L11.9143 9.13635C11.5392 8.76141 11.0306 8.55078 10.5003 8.55078C9.96994 8.55078 9.46133 8.76141 9.08627 9.13635L8.02894 10.1937C7.9075 10.3194 7.8403 10.4878 7.84182 10.6626C7.84334 10.8374 7.91345 11.0046 8.03706 11.1282C8.16066 11.2518 8.32787 11.322 8.50267 11.3235C8.67747 11.325 8.84587 11.2578 8.9716 11.1364L9.8336 10.2744V15.3317C9.8336 15.5085 9.90384 15.6781 10.0289 15.8031C10.1539 15.9281 10.3235 15.9984 10.5003 15.9984C10.6771 15.9984 10.8467 15.9281 10.9717 15.8031C11.0967 15.6781 11.1669 15.5085 11.1669 15.3317V10.2744L12.0289 11.1364C12.154 11.2613 12.3235 11.3315 12.5003 11.3315C12.677 11.3315 12.8466 11.2613 12.9716 11.1364Z" fill="white"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_212_9007">
                              <rect width="16" height="16" fill="white" transform="translate(0.5)"/>
                              </clipPath>
                              </defs>
                              </svg>

                          </div>
                          {preview_Images_logo?.url != null ? (
                            <img
                              style={{
                                width: "100%",
                                height: "250px",
                                marginTop: '-10px'
                              }}
                              src={preview_Images_logo?.url}
                              alt="Upload preview"
                            />
                          ) : (
                            <>
                              <div className="parent">
                                <div className="child">
                                  <div className="logo-container">
                                    <div>
                                      <svg
                                        className="logo"
                                        width="101"
                                        height="100"
                                        viewBox="0 0 101 100"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle
                                          cx="50.5"
                                          cy="50"
                                          r="50"
                                          fill="#D9D9D9"
                                        />
                                        <text
                                          x="50%"
                                          y="50%"
                                          dominant-baseline="middle"
                                          text-anchor="middle"
                                          fill="black"
                                          font-family= "DM Sans, Helvetica"
                                            font-size= "18"
                                            font-weight= "700"
                                            line-height= "24"
                                          
                                        >
                                          Logo
                                        </text>
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="empty-logo-text">Your logo goes here</div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="logo-text">
                          <div
                            className="edit-icon"
                            onClick={toggleIsCalloutVisible_Images}
                            id="callout-button-1"
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_212_8997)">
                              <path d="M12.438 0.62135L4.31 8.74935C3.99956 9.05811 3.75345 9.42539 3.58592 9.82991C3.41839 10.2344 3.33276 10.6682 3.334 11.106V12.0014C3.334 12.1782 3.40424 12.3477 3.52926 12.4728C3.65428 12.5978 3.82385 12.668 4.00066 12.668H4.896C5.33384 12.6693 5.76758 12.5836 6.1721 12.4161C6.57663 12.2486 6.9439 12.0025 7.25266 11.692L15.3807 3.56402C15.7703 3.17346 15.9891 2.64433 15.9891 2.09268C15.9891 1.54103 15.7703 1.0119 15.3807 0.62135C14.9844 0.242613 14.4574 0.03125 13.9093 0.03125C13.3612 0.03125 12.8342 0.242613 12.438 0.62135ZM14.438 2.62135L6.31 10.7494C5.93408 11.123 5.426 11.3333 4.896 11.3347H4.66733V11.106C4.66872 10.576 4.87904 10.0679 5.25266 9.69202L13.3807 1.56402C13.5231 1.42799 13.7124 1.35208 13.9093 1.35208C14.1063 1.35208 14.2956 1.42799 14.438 1.56402C14.578 1.70436 14.6566 1.89448 14.6566 2.09268C14.6566 2.29089 14.578 2.48101 14.438 2.62135Z" fill="#D9D9D9"/>
                              <path d="M15.3333 5.986C15.1565 5.986 14.987 6.05624 14.8619 6.18126C14.7369 6.30629 14.6667 6.47586 14.6667 6.65267V10H12C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12V14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V3.33333C1.33333 2.8029 1.54405 2.29419 1.91912 1.91912C2.29419 1.54405 2.8029 1.33333 3.33333 1.33333H9.36133C9.53815 1.33333 9.70771 1.2631 9.83274 1.13807C9.95776 1.01305 10.028 0.843478 10.028 0.666667C10.028 0.489856 9.95776 0.320286 9.83274 0.195262C9.70771 0.0702379 9.53815 0 9.36133 0L3.33333 0C2.4496 0.00105857 1.60237 0.352588 0.97748 0.97748C0.352588 1.60237 0.00105857 2.4496 0 3.33333L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H10.8953C11.3333 16.0013 11.7671 15.9156 12.1718 15.7481C12.5764 15.5806 12.9438 15.3345 13.2527 15.024L15.0233 13.252C15.3338 12.9432 15.58 12.576 15.7477 12.1715C15.9153 11.767 16.0011 11.3332 16 10.8953V6.65267C16 6.47586 15.9298 6.30629 15.8047 6.18126C15.6797 6.05624 15.5101 5.986 15.3333 5.986ZM12.31 14.0813C12.042 14.3487 11.7031 14.5337 11.3333 14.6147V12C11.3333 11.8232 11.4036 11.6536 11.5286 11.5286C11.6536 11.4036 11.8232 11.3333 12 11.3333H14.6167C14.5342 11.7023 14.3493 12.0406 14.0833 12.3093L12.31 14.0813Z" fill="#D9D9D9"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_212_8997">
                              <rect width="16" height="16" fill="white"/>
                              </clipPath>
                              </defs>
                              </svg>

                          </div>
                          <input type='text' style={{ fontFamily: 'Source Sans Pro', border: 'none', outline: 'none', background: 'none', width:'100%',fontSize:'27px', color: imageBordercolor != "" ? imageBordercolor : "#d9d9d9", textAlign: 'center', marginTop: '-15px'}} value={textchangeHeading} maxLength={50} onChange={(e)=>handleTextChange(e, 'Heading')} />
                        </div>
                        <div className="logo-text">
                          <div
                            className="edit-icon"
                            onClick={toggleIsCalloutVisible_Url}
                            id="callout-button-3"
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_212_8997)">
                                <path d="M12.438 0.62135L4.31 8.74935C3.99956 9.05811 3.75345 9.42539 3.58592 9.82991C3.41839 10.2344 3.33276 10.6682 3.334 11.106V12.0014C3.334 12.1782 3.40424 12.3477 3.52926 12.4728C3.65428 12.5978 3.82385 12.668 4.00066 12.668H4.896C5.33384 12.6693 5.76758 12.5836 6.1721 12.4161C6.57663 12.2486 6.9439 12.0025 7.25266 11.692L15.3807 3.56402C15.7703 3.17346 15.9891 2.64433 15.9891 2.09268C15.9891 1.54103 15.7703 1.0119 15.3807 0.62135C14.9844 0.242613 14.4574 0.03125 13.9093 0.03125C13.3612 0.03125 12.8342 0.242613 12.438 0.62135ZM14.438 2.62135L6.31 10.7494C5.93408 11.123 5.426 11.3333 4.896 11.3347H4.66733V11.106C4.66872 10.576 4.87904 10.0679 5.25266 9.69202L13.3807 1.56402C13.5231 1.42799 13.7124 1.35208 13.9093 1.35208C14.1063 1.35208 14.2956 1.42799 14.438 1.56402C14.578 1.70436 14.6566 1.89448 14.6566 2.09268C14.6566 2.29089 14.578 2.48101 14.438 2.62135Z" fill="#D9D9D9" />
                                <path d="M15.3333 5.986C15.1565 5.986 14.987 6.05624 14.8619 6.18126C14.7369 6.30629 14.6667 6.47586 14.6667 6.65267V10H12C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12V14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V3.33333C1.33333 2.8029 1.54405 2.29419 1.91912 1.91912C2.29419 1.54405 2.8029 1.33333 3.33333 1.33333H9.36133C9.53815 1.33333 9.70771 1.2631 9.83274 1.13807C9.95776 1.01305 10.028 0.843478 10.028 0.666667C10.028 0.489856 9.95776 0.320286 9.83274 0.195262C9.70771 0.0702379 9.53815 0 9.36133 0L3.33333 0C2.4496 0.00105857 1.60237 0.352588 0.97748 0.97748C0.352588 1.60237 0.00105857 2.4496 0 3.33333L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H10.8953C11.3333 16.0013 11.7671 15.9156 12.1718 15.7481C12.5764 15.5806 12.9438 15.3345 13.2527 15.024L15.0233 13.252C15.3338 12.9432 15.58 12.576 15.7477 12.1715C15.9153 11.767 16.0011 11.3332 16 10.8953V6.65267C16 6.47586 15.9298 6.30629 15.8047 6.18126C15.6797 6.05624 15.5101 5.986 15.3333 5.986ZM12.31 14.0813C12.042 14.3487 11.7031 14.5337 11.3333 14.6147V12C11.3333 11.8232 11.4036 11.6536 11.5286 11.5286C11.6536 11.4036 11.8232 11.3333 12 11.3333H14.6167C14.5342 11.7023 14.3493 12.0406 14.0833 12.3093L12.31 14.0813Z" fill="#D9D9D9" />
                              </g>
                              <defs>
                                <clipPath id="clip0_212_8997">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          {/* <div style={{ paddingTop: "5px" }} contentEditable onInput={(e) => handleTextChange(e)} onKeyDown={handleKeyDown}>
                            {textchangeHeading}
                          </div> */}
                          <textarea
                          rows={2}
                            placeholder="www.yourcollegewebsite.com"
                            style={{
                              fontFamily: 'Lato',
                              border: 'none',
                              outline: 'none',
                              background: 'none',
                              width: '100%',
                              color: urlColor !== "" ? urlColor : "#d9d9d9",
                              textAlign: 'center',
                              resize: 'none',
                              marginTop: '-15px'
                            }}
                            value={textchangeUrl}
                            maxLength={160}
                            onChange={(e) => handleTextChange(e, 'Url')}
                          />

                          </div>
                      </div>
                    </div>
                  </div>
                
              </div>
            </div>
          </div>

          <div className="frame-27">
            <div className="button-wrap">
            <button className="primary-BTN">
                            <Link className="button-text" to="/StudentClipSettings" >Back</Link>
                        </button>

              <button className="button-text-7">
                <button className="button-text-wrapper" onClick={handleSaveContinueClick}>{buttonText()}</button>
              </button>
            </div>
          </div>

          <ImageModal
            modalIsOpen={isCroppingForLogo}
            ratio={500/500}
            onClose={onCloseCropper}
            image={selectedImageForCropping}
            onCropCompleted={(area) => {
              setCompletedCrop(area);
            }}
            onUpload={(file) => {
              setSelectedFiles(file);
            }}
            onFileCropping={(file) => {
              if (completedCrop.width >= 500 && completedCrop.height >= 500) {
              setIsCroppingForLogo(false);
              setPreview_Images_logo({name: selectedImageForCropping.name, url: file.url, uploadedData: false })
              } else {
                toastError('Cropped image minimum dimensions must be 500x100');
              }
            }}
          />

          <Modal
            titleAriaId={"title"}
            isOpen={isModalOpen_Images_logo}
            onDismiss={handleCloseModal}
            isBlocking={false}
            containerClassName={contentStyles.container}

          // dragOptions={isDraggable ? dragOptions : undefined}
          >
            <div className="uploadContainer" style={{ width: '540px', height: '540px', padding: '0px 35px' }}>
              <div className="div-2">
                <button className="CTA" onClick={render_preview_logo}
                  disabled={!isLogoUploaded} // Disable the button if logoUploaded is false
                  style={{
                    opacity: isLogoUploaded ? 1 : 0.5,
                    cursor: isLogoUploaded ? 'pointer' : 'not-allowed'
                  }}>
                  <div className="label">UPLOAD LOGO</div>
                </button>
                <div className="heading-upload">
                  <div className="text-wrapper">Upload Logo</div>
                </div>

                <div className="upload-file-area" onClick={openUpload_logo}>
                  <div className="frame-2">
                    <img
                      className="upload-icon"
                      alt="Upload icon"
                      src={uploadIcon} />
                    <div className="frame-3">
                      <div className="drag-drop-files">
                        <p className="drag-drop-files-or">
                          <span className="span">Drag & drop files or </span>
                          <span className="text-wrapper-2">Browse</span>
                        </p>
                        <input
                          id="image_upload_logo"
                          onChange={(e) => handleOnChange_logo(e)}
                          style={{ display: "none" }}
                          type="file"
                          accept="image/png"
                        />
                      </div>
                      <div className={`frame frame-1027`}>
                        <div className="div" style={{ display: 'flex', gap: '2px' }}>
                          <Checkbox className="checkbox-instance" property1="fi-sr-info" />
                          <p className="i-authorise">Kindly upload logos in .png format ensuring they have a<br /> transparent background. Ensure there is minimal<br /> blank space surrounding the logo, and that its dimensions<br /> are at least 500x500 pixels</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          {isCalloutVisible_Images && (
            <Callout
              className={styles1.callout}
              ariaLabelledBy={"callout-label"}
              ariaDescribedBy={"callout-description"}
              role="dialog"
              gapSpace={0}
              target={`#callout-button-1`}
              onDismiss={toggleIsCalloutVisible_Images}
              setInitialFocus
            >
              <ColorPicker
                color={imageBordercolor}
                onChange={onChangeBackgroundColor_Images}
                alphaType="none"
                showPreview={false}
                styles={colorPickerStyles}
                strings={{
                  hueAriaLabel: "Hue",
                }}
              />
            </Callout>
          )}

          {isCalloutVisible_Heading && (
            <Callout
              className={styles1.callout}
              ariaLabelledBy={"callout-label"}
              ariaDescribedBy={"callout-description"}
              role="dialog"
              gapSpace={0}
              target={`#callout-button-2`}
              onDismiss={toggleIsCalloutVisible_Heading}
              setInitialFocus
            >
              <ColorPicker
                color={headingColor}
                onChange={onChangeBackgroundColor_Heading}
                alphaType="none"
                showPreview={false}
                styles={colorPickerStyles}
                strings={{
                  hueAriaLabel: "Hue",
                }}
              />
            </Callout>
          )}

          {isCalloutVisible_Url && (
            <Callout
              className={styles1.callout}
              ariaLabelledBy={'callout-label'}
              ariaDescribedBy={'callout-description'}
              role="dialog"
              gapSpace={0}
              target={`#callout-button-3`}
              onDismiss={toggleIsCalloutVisible_Url}
              setInitialFocus
            >
              <ColorPicker
                color={urlColor}
                onChange={onChangeBackgroundColor_Url}
                alphaType='none'
                showPreview={false}
                styles={colorPickerStyles}
                strings={{
                  hueAriaLabel: 'Hue',
                }}
              />
            </Callout>
          )}

          {loading && (
            <div className="loader-container">
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px' }}>
                <CircularProgress />
              </Box>
            </div>
          )}

        </div>
      </div>
      
    </div>
  );
};
const colorPickerStyles = {
  panel: { padding: 12 },
  root: {
    maxWidth: 352,
    //minWidth: 352,
  },
  colorRectangle: { height: 268 },
};
const styles1 = mergeStyleSets({
  button: {
    width: 130,
  },
  callout: {
    width: 320,
    maxWidth: "90%",
    padding: "20px 24px",
  },
  title: {
    marginBottom: 12,
    fontWeight: FontWeights.semilight,
  },
  link: {
    display: "block",
    marginTop: 20,
  },
});
// Images Popup
const cancelIcon = { iconName: "Cancel" };

const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch"
  },
  header: [
    theme.fonts.xLargePlus,
    {
      flex: "1 1 auto",
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: "flex",
      alignItems: "center",
      fontWeight: FontWeights.semibold,
      padding: "12px 12px 14px 24px",
    },
  ],
  heading: {
    color: theme.palette.neutralPrimary,
    fontWeight: FontWeights.semibold,
    fontSize: "inherit",
    margin: "0",
  },
  body: {
    flex: "4 4 auto",
    padding: "0 24px 24px 24px",
    overflowY: "hidden",
    selectors: {
      p: { margin: "14px 0" },
      "p:first-child": { marginTop: 0 },
      "p:last-child": { marginBottom: 0 },
    },
  },
});
const stackProps = {
  horizontal: true,
  tokens: { childrenGap: 40 },
  styles: { root: { marginBottom: 20 } },
};
const iconButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: "auto",
    marginTop: "4px",
    marginRight: "2px",
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};




const mapStateToProps = (state) => {
  return {
    loading: state.seasonSettings.loading,
    clientMasterData: state.seasonSettings.clientMasterData,
    selectedSeason: state.seasonSettings.selectedSeason,
    exitVideoDataForSettings: state.seasonSettings.exitVideoDataForSettings,
    eventSuccess: state.seasonSettings.eventSuccess,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchClientMaster: (eventData) => dispatch(fetchClientMaster(eventData)),
    getExitVideoData: (eventData) => dispatch(getExitVideoForSettings(eventData)),
    getSelectedSeason: (eventData) => dispatch(getSelectedSeason(eventData)),
    createSeasonSettingsClientMaster: (clientData) =>
      dispatch(createSeasonSettingsClientMaster(clientData)),
    postExitVideo: (files, introData) => dispatch(postExitVideoForSettings(files, introData)),
    setEventSuccess: (flag) => dispatch(setEventSuccess(flag)),
  };
};

const ConnectedSeasonsCreateExitClipFrame = connect(mapStateToProps, mapDispatchToProps)(CreateExitClipFrameSeasonSettings);

export { ConnectedSeasonsCreateExitClipFrame as CreateExitClipFrameSeasonSettings };
